import { useEffect, useState } from 'react';
import {
  HStack,
  Stack,
  FormControl,
  FormLabel
} from '@chakra-ui/react';
import SearchBar from 'components/SearchBar/SearchBar';
import UserRoleDropdown from 'components/Dropdown/UserRoleDropdown/UserRoleDropdown';
import UserAccountStatusDropdown from 'components/Dropdown/UserAccountStatusDropdown/UserAccountStatusDropdown';
import { UserAccountStatus, UserRole } from 'models/User/User';

export interface UserFiltersProps {
  defaultQuery?: string;
  defaultStatus?: UserAccountStatus;
  defaultRole?: UserRole;
  onQueryChange?: (query: string) => void;
  onStatusChange?: (status?: UserAccountStatus) => void;
  onRoleChange?: (role?: UserRole) => void;
}

export default function UserFilters({
  defaultQuery = '',
  defaultStatus,
  defaultRole,
  onQueryChange,
  onStatusChange,
  onRoleChange
}: UserFiltersProps) {
  const [query, setQuery] = useState(defaultQuery);
  const [status, setStatus] = useState<UserAccountStatus | undefined>(defaultStatus);
  const [role, setRole] = useState<UserRole | undefined>(defaultRole);

  useEffect(() => {
    setQuery(defaultQuery);
  }, [defaultQuery]);

  useEffect(() => {
    setStatus(defaultStatus);
  }, [defaultStatus]);

  useEffect(() => {
    setRole(defaultRole);
  }, [defaultRole]);

  const handleQueryChange = (value: string) => {
    setQuery(value);
    onQueryChange?.(value);
  };

  const handleStatusChange = (value?: UserAccountStatus) => {
    setStatus(value);
    onStatusChange?.(value);
  };

  const handleRoleChange = (value?: UserRole) => {
    setRole(value);
    onRoleChange?.(value);
  };

  return (
    <Stack spacing={4}>
      <HStack spacing={4} alignItems="flex-end">
        <FormControl flex={2}>
          <SearchBar
            onChange={handleQueryChange}
            defaultValue={query}
            inputPlaceholder="Search by email, username, or name"
          />
        </FormControl>
        <FormControl flex={1}>
          <FormLabel fontSize="sm" htmlFor="user-status-filter">Account Status</FormLabel>
          <UserAccountStatusDropdown
            value={status}
            onChange={handleStatusChange}
            size="md"
          />
        </FormControl>
        <FormControl flex={1}>
          <FormLabel fontSize="sm" htmlFor="user-role-filter">Role</FormLabel>
          <UserRoleDropdown
            value={role}
            onChange={handleRoleChange}
            size="md"
          />
        </FormControl>
      </HStack>
    </Stack>
  );
}
